export default __webpack_public_path__ + "static/media/expnadIconLeft.bc2c05b7.svg";